import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "user-area-footer footer",
  "aria-label": "Footer"
}
const _hoisted_2 = {
  "aria-label": "Footer Navigation",
  role: "navigation"
}
const _hoisted_3 = {
  class: "user-area-footer__menu",
  role: "menu"
}
const _hoisted_4 = {
  key: 0,
  role: "menuitem"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 1,
  role: "menuitem"
}
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = {
  key: 2,
  role: "menuitem"
}
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = {
  key: 3,
  role: "menuitem"
}
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = {
  key: 4,
  role: "menuitem"
}
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 5,
  role: "menuitem"
}
const _hoisted_15 = ["aria-label"]

import { useAppStore } from '@/stores/app.store';
import useTranslations from '@/composables/useTranslations';
import { computed, ref } from 'vue';
import LanguageSelector from '@/components/common/languageSelector/LanguageSelector.vue';
import FeedbackDialog from '../common/dialogs/DialogFeedback.vue';
import { layoutAreaTypes } from '@/types/layoutTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaFooter',
  setup(__props) {

const appStore = useAppStore();
const { translate: t } = useTranslations();

const feedbackDialogRef = ref();
const systemSettings = computed(() => {
  return appStore.systemSettings;
});

function handleFeedbackBtnClick() {
  feedbackDialogRef.value.openDialog();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (systemSettings.value?.footerMenuViewModel?.isManualVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createElementVNode("a", {
                  class: "user-area-footer__link",
                  href: "/Pages/Overview",
                  role: "button",
                  tabindex: "0",
                  "aria-label": _unref(t)('Page') + ' - ' + systemSettings.value?.footerMenuViewModel?.manualLabel
                }, _toDisplayString(systemSettings.value?.footerMenuViewModel?.manualLabel), 9, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          (systemSettings.value?.footerMenuViewModel?.isAccessibilityVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createElementVNode("a", {
                  class: "user-area-footer__link",
                  href: "/Pages/Accessibility",
                  role: "button",
                  tabindex: "0",
                  "aria-label": 
              _unref(t)('Page') + ' - ' + systemSettings.value?.footerMenuViewModel?.accessibilityLabel
            
                }, _toDisplayString(systemSettings.value?.footerMenuViewModel?.accessibilityLabel), 9, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          (systemSettings.value?.footerMenuViewModel?.isTermsOfUseVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createElementVNode("a", {
                  class: "user-area-footer__link",
                  href: "/Pages/TermsOfUse",
                  role: "button",
                  tabindex: "0",
                  "aria-label": _unref(t)('Page') + ' - ' + systemSettings.value?.footerMenuViewModel?.termsOfUseLabel
                }, _toDisplayString(systemSettings.value?.footerMenuViewModel?.termsOfUseLabel), 9, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (systemSettings.value?.footerMenuViewModel?.isPrivacyVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createElementVNode("a", {
                  class: "user-area-footer__link",
                  href: "/Pages/Privacy",
                  role: "button",
                  tabindex: "0",
                  "aria-label": _unref(t)('Page') + ' - ' + systemSettings.value?.footerMenuViewModel?.privacyLabel
                }, _toDisplayString(systemSettings.value?.footerMenuViewModel?.privacyLabel), 9, _hoisted_11)
              ]))
            : _createCommentVNode("", true),
          (systemSettings.value?.footerMenuViewModel?.isImprintVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createElementVNode("a", {
                  class: "user-area-footer__link",
                  href: "/Pages/Imprint",
                  role: "button",
                  tabindex: "0",
                  "aria-label": _unref(t)('Page') + ' - ' + systemSettings.value?.footerMenuViewModel?.imprintLabel
                }, _toDisplayString(systemSettings.value?.footerMenuViewModel?.imprintLabel), 9, _hoisted_13)
              ]))
            : _createCommentVNode("", true),
          (systemSettings.value?.footerMenuViewModel?.isYourFeedbackVisible)
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("span", {
                  class: "user-area-footer__link user-area-footer__link--feedback",
                  role: "button",
                  tabindex: "0",
                  "aria-label": _unref(t)('Page') + ' - ' + _unref(t)('Page.FeedbackFormLink'),
                  onKeyup: _withKeys(handleFeedbackBtnClick, ["enter"]),
                  onClick: handleFeedbackBtnClick
                }, _toDisplayString(_unref(t)('Page.FeedbackFormLink')), 41, _hoisted_15)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(LanguageSelector, { role: "group" })
    ]),
    _createVNode(FeedbackDialog, {
      ref_key: "feedbackDialogRef",
      ref: feedbackDialogRef,
      "layout-area-type": _unref(layoutAreaTypes).User
    }, null, 8, ["layout-area-type"])
  ], 64))
}
}

})